export var ACTION;
(function (ACTION) {
    ACTION["HELP_ACTION"] = "HELP_ACTION";
    ACTION["ON_LOAD"] = "ON_LOAD";
    ACTION["CONTINUE_ACTION"] = "CONTINUE_ACTION";
})(ACTION || (ACTION = {}));
